import { render, staticRenderFns } from "./authentication-options.vue?vue&type=template&id=63e41054&scoped=true&"
import script from "./authentication-options.vue?vue&type=script&lang=js&"
export * from "./authentication-options.vue?vue&type=script&lang=js&"
import style0 from "./authentication-options.vue?vue&type=style&index=0&id=63e41054&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e41054",
  null
  
)

export default component.exports